import { Link } from "react-router-dom";
import { Globe, Mail, Linkedin, Twitter, Youtube } from "lucide-react";
import { Separator } from "@/components/ui/separator";

const footerLinks = {
  platform: [
    { label: "How It Works", href: "/how-it-works" },
    { label: "AI Features", href: "/ai-features" },
    { label: "Language Teachers", href: "/teachers" },
    { label: "Cultural Events", href: "/events" },
    { label: "Pricing", href: "/pricing" },
  ],
  organizations: [
    { label: "For Enterprises", href: "/enterprise" },
    { label: "For Universities", href: "/universities" },
    { label: "For Governments", href: "/government" },
  ],
  company: [
    { label: "About Us", href: "/about" },
    { label: "Contact", href: "/contact" },
    { label: "Blog", href: "/blog" },
    { label: "Careers", href: "/careers" },
    { label: "Privacy Policy", href: "/privacy" },
    { label: "Terms of Service", href: "/terms" },
  ],
  resources: [
    { label: "Help Center", href: "/help" },
    { label: "API Docs", href: "/api-docs" },
    { label: "Language Guide", href: "/guide" },
    { label: "Donate", href: "http://www.lingua2.net/", external: true },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-foreground text-primary-foreground">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8 lg:gap-10">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-7 h-7 rounded-md bg-primary flex items-center justify-center">
                <Globe className="w-4 h-4 text-primary-foreground" strokeWidth={2.5} />
              </div>
              <span className="text-lg font-display font-bold">
                Lingua<span className="text-primary">2</span>
              </span>
            </div>
            <p className="text-sm text-primary-foreground/60 leading-relaxed mb-6 max-w-xs">
              The world's leading AI-enhanced language exchange platform for enterprises, universities, and governments.
            </p>
            {/* Iconos de redes sociales COMENTADOS */}
            {/*
            <div className="flex items-center gap-2">
              {[
                { icon: Linkedin, href: "#" },
                { icon: Twitter, href: "#" },
                { icon: Youtube, href: "#" },
              ].map(({ icon: Icon, href }, i) => (
                <a
                  key={i}
                  href={href}
                  className="w-8 h-8 rounded-md bg-primary-foreground/8 flex items-center justify-center hover:bg-primary transition-fast"
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
            */}
          </div>

          {["platform", "organizations", "company", "resources"].map((section) => (
            <div key={section}>
              <h4 className="text-xs font-semibold uppercase tracking-wider text-primary-foreground/40 mb-4">
                {section.charAt(0).toUpperCase() + section.slice(1)}
              </h4>
              <ul className="space-y-2.5">
                {footerLinks[section].map((link) => (
                  <li key={link.label}>
                    {link.external ? (
                      <a
                        href={link.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-sm text-primary-foreground/60 hover:text-primary transition-fast"
                      >
                        {link.label}
                      </a>
                    ) : (
                      <Link
                        to={link.href}
                        className="text-sm text-primary-foreground/60 hover:text-primary transition-fast"
                      >
                        {link.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <Separator className="my-8 bg-primary-foreground/10" />

        <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-primary-foreground/40">
            &copy; {new Date().getFullYear()} Lingua2. All rights reserved.
          </p>
          {/* Enlaces de Privacy, Terms, Cookies COMENTADOS */}
          {/*
          <div className="flex items-center gap-5">
            {["Privacy", "Terms", "Cookies"].map((item) => (
              <Link
                key={item}
                to={`/${item.toLowerCase()}`}
                className="text-xs text-primary-foreground/40 hover:text-primary-foreground/70 transition-fast"
              >
                {item}
              </Link>
            ))}
          </div>
          */}
        </div>
      </div>
    </footer>
  );
}